import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Hero from './components/landingPage/hero';
import Entryform from './components/loanForm/Entryform';
import Login from './components/login';
import { Bottom } from './components/landingPage/CTA';
import Portal from './components/customerPortal/portal';
import { Header } from './components/landingPage/header';
import Footer from './components/landingPage/footer';
import StatSection from './components/landingPage/stats';
import AdminDashboard from './components/admin/AdminDashboard';
import AdminSignUp from './components/admin/adminsignup';
import AdminLogin from './components/admin/adminlogin';
import ForgotPassword from './components/forgotpassword';
import LoanDetails from './components/admin/loandetails';
import LoanApplicationForm from './components/customerPortal/loanform';
import AuthFormSearcher from './components/loanForm/AuthFormSearcher';
import AuthFormApplication from './components/loanForm/AuthFormApplication';
import BankForm from './components/bank/bankform';
import BankPortal from './components/bank/BankPortal';
import BankLoanDetails from './components/bank/bankloandetails';
import BrokerPortal from './components/Seller/brokerPortal';
import BrokerSignup from './components/Seller/brokerSignup';
import PrequalSignup from './components/Seller/PrequalSignup';
import PrequalificationDetails from './components/admin/prequalificationDetails';
import BankPrequalificationDetails from './components/bank/BankPrequalificationDetails';
import LoanCalculator from './components/landingPage/LoanCalculator';
import AuthFormWorking from './components/loanForm/AuthFormWorking';
import SharedUploadPage from './components/admin/SharedUploadPage';
import WhiteLabelApplicationPage from './components/Seller/WhiteLabel';
import EmailVerificationUpload from './components/admin/EmailVerificationUpload';
import AuthFormNew from './components/loanForm/AuthFormNew';
import NewApplication from './components/admin/NewApplication';
import BenPortal from './components/admin/BenPortal';
import PendingSearcherUpload from './components/admin/PendingSearcherUpload';
import AdminNewListing from './components/admin/AdminNewListing';
import BrokerDealUpload from './components/Seller/BrokerDealUpload';
import ProtectedRoute from './components/auth/ProtectedRoute';
import SalesRepPortal from './components/sales/SalesRepPortal';

const ADMIN_EMAILS = ['jake88potter@gmail.com'];
// Anyone in BEN_EMAILS lands on the Ben portal on sign-in and can access /ben-portal.
const BEN_EMAILS = ['ben@lended.ai', 'isak@lended.ai'];
const SALES_PORTAL_EMAILS = ['isak@lended.ai'];
const ALL_ADMIN = [...ADMIN_EMAILS, ...BEN_EMAILS];

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={
          <>
            <Header />
            <Hero />
            <section className="border-y border-blue-700 bg-blue-600 py-8 text-white">
              <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-4 text-center sm:px-6 lg:grid-cols-4 lg:px-8">
                {[
                  ['$100M+', 'SBA loans closed in the past 12 months'],
                  ['40+', 'preferred SBA lenders'],
                  ['24–48 hrs', 'to lender-ready term sheets'],
                  ['~45 days', 'typical Lended closing'],
                ].map(([value, label]) => <div key={label}><p className="text-2xl font-bold text-white sm:text-3xl">{value}</p><p className="mt-1 text-xs leading-5 text-blue-50 sm:text-sm">{label}</p></div>)}
              </div>
            </section>
            <section className="py-24">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl"><p className="text-sm font-semibold uppercase tracking-wider text-blue-600">One process, full lender market</p><h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-5xl">From target company to closing without the lender runaround.</h2></div>
                <div className="mt-12 grid gap-5 lg:grid-cols-3">
                  {[
                    ['01', 'Build one lender-ready file', 'Upload buyer and target-company information once. We organize the package around how acquisition lenders actually underwrite.'],
                    ['02', 'Match the structure to the lender', 'We compare your buyer profile, industry, cash flow, equity, and timeline across a network of 40+ preferred SBA lenders.'],
                    ['03', 'Move from term sheet to close', 'Track diligence, documents, lender requests, and next steps in one process with an acquisition-finance team beside you.'],
                  ].map(([number, title, copy]) => <article key={number} className="rounded-3xl border border-blue-100 bg-white p-7 shadow-sm transition hover:-translate-y-1 hover:shadow-lg"><span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-sky-50 text-sm font-bold text-blue-600">{number}</span><h3 className="mt-6 text-xl font-semibold text-slate-900">{title}</h3><p className="mt-3 leading-7 text-slate-600">{copy}</p></article>)}
                </div>
              </div>
            </section>
            <section className="bg-gradient-to-br from-sky-50 via-white to-blue-50 py-24">
              <div className="mx-auto grid max-w-7xl items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
                <div><p className="text-sm font-semibold uppercase tracking-wider text-blue-600">Built for acquisition complexity</p><h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">Financing for more than one kind of buyer.</h2><p className="mt-5 text-lg leading-8 text-slate-600">Self-funded searchers, first-time buyers, existing companies completing add-ons, management teams, and industry operators all need different lender fits.</p><a href="/searchersignup" className="mt-7 inline-flex rounded-xl bg-blue-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700">See what you qualify for →</a></div>
                <div className="grid gap-4 sm:grid-cols-2">{['Self-funded searchers','First-time business buyers','Add-on acquisitions','Management buyouts','Professional practices','Home-services companies'].map((buyer) => <div key={buyer} className="flex items-center gap-3 rounded-2xl border border-sky-100 bg-white p-4 shadow-sm"><span className="flex h-8 w-8 items-center justify-center rounded-full bg-sky-50 text-blue-600">✓</span><span className="font-medium text-slate-800">{buyer}</span></div>)}</div>
              </div>
            </section>
            <StatSection/>
            <section className="bg-sky-50/60 py-20">
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid items-center gap-10 lg:grid-cols-[1fr_1.2fr]">
                  <div>
                    <p className="text-sm font-semibold uppercase tracking-wider text-blue-600">Acquisition financing insights</p>
                    <h2 className="mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl">Get clear answers before you structure the deal.</h2>
                    <p className="mt-4 text-lg leading-8 text-slate-600">Explore 60+ practitioner guides covering equity injections, seller notes, underwriting, timelines, buyer types, and industry-specific acquisitions.</p>
                    <a href="/resources/" className="mt-7 inline-flex rounded-xl bg-blue-600 px-5 py-3 text-sm font-semibold text-white shadow-sm hover:bg-blue-700">Browse the insight library →</a>
                  </div>
                  <div className="grid gap-4 sm:grid-cols-2">
                    {[
                      ['Down payments', 'How equity injections and standby seller notes work.'],
                      ['Underwriting', 'DSCR, add-backs, tax returns, credit, and collateral.'],
                      ['Deal structure', 'Sources and uses, working capital, goodwill, and investors.'],
                      ['Industry guides', 'Acquisition financing for HVAC, CPA, medical, and more.'],
                    ].map(([title, copy]) => (
                      <a key={title} href="/resources/" className="rounded-2xl border border-sky-100 bg-white p-5 shadow-sm transition hover:-translate-y-0.5 hover:border-blue-200 hover:shadow-md">
                        <h3 className="font-semibold text-slate-900">{title}</h3>
                        <p className="mt-2 text-sm leading-6 text-slate-600">{copy}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </section>
            <section className="mt-20 mb-20">
              <Bottom />
            </section>
            <Footer />
          </>
        } />
        <Route path="/login" element={<Login />} />
        <Route path="/searchersignup" element={<AuthFormSearcher />} />
        {/* Back-compat redirect for any old emails / links pointing at the dashed slug. */}
        <Route path="/searcher-signup" element={<Navigate to="/searchersignup" replace />} />
        <Route path="/workingcapitalsignup" element={<AuthFormWorking />} />
        <Route path="/signup" element={<AuthFormApplication />} />
        <Route path="/portal" element={<Portal />} />
        <Route path="/admindashboard" element={<ProtectedRoute allowedEmails={ADMIN_EMAILS}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin-portal" element={<ProtectedRoute allowedEmails={ADMIN_EMAILS}><AdminDashboard /></ProtectedRoute>} />
        <Route path="/admin/new-application" element={<ProtectedRoute allowedEmails={ADMIN_EMAILS}><NewApplication /></ProtectedRoute>} />
        <Route path="/ben-portal" element={<ProtectedRoute allowedEmails={BEN_EMAILS}><BenPortal /></ProtectedRoute>} />
        <Route path="/sales-portal" element={<ProtectedRoute allowedEmails={SALES_PORTAL_EMAILS} requiredClaim="salesRep" redirectTo="/login"><SalesRepPortal /></ProtectedRoute>} />
        <Route path="/admin/new-listing" element={<ProtectedRoute allowedEmails={ALL_ADMIN}><AdminNewListing /></ProtectedRoute>} />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route path="/adminsignup" element={<AdminSignUp />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/loan-details/:loanId" element={<ProtectedRoute allowedEmails={ALL_ADMIN}><LoanDetails /></ProtectedRoute>} />
        <Route path="/loanform" element={<LoanApplicationForm />} />
        <Route path="/entryform" element={<Entryform />} />
        <Route path="/add-bank" element={<BankForm />} />
        <Route path="/bank-portal" element={<BankPortal />} />      
        <Route path="/bank-loan-details/:loanId" element={<BankLoanDetails />} />     
        <Route path="/broker-signup" element={<BrokerSignup />} />
        <Route path="/broker-portal" element={<BrokerPortal />} />
        <Route path="/prequalification-details/:prequalId" element={<ProtectedRoute allowedEmails={ALL_ADMIN}><PrequalificationDetails /></ProtectedRoute>} />
        <Route path="/bank-portal/prequalification/:prequalId" element={<BankPrequalificationDetails />} />
        <Route path="/loan-calculator" element={
          <>
            <Header />
            <LoanCalculator />
            <Footer />
          </>
        } />
        <Route path="/shared-upload-verify" element={<EmailVerificationUpload />} />
        <Route path="/shared-upload/:loanId" element={<SharedUploadPage />} />
        <Route path="/upload/:pendingId" element={<PendingSearcherUpload />} />
        <Route path="/broker-deal/:brokerId" element={<BrokerDealUpload />} />
        <Route path="/upload-docs/:pendingId" element={<PendingSearcherUpload />} />
        <Route path="/broker-application/:brokerId" element={<WhiteLabelApplicationPage />} />
        <Route path="/prequal-signup/:prequalId" element={<PrequalSignup />} />
        <Route path="/lendermatchsignup" element={<AuthFormNew />} />
      </Routes>
    </Router>
  );
}

export default App;
